import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from 'States/auth/authState';
import { ROUTES } from 'Router/Routes';

const SidebarLink = ({ link }) => {
  const { isAdmin, isAuthenticated } = useContext(AuthContext);
  const {
    route = "",
    href = "",
    text = "",
    onClick = () => { },
    dataQa,
    active,
    enabled = true,
    external = false,
    newTab = false,
    requiresAuth = false,
    adminOnly = false,
    state = {}
  } = link;
  if (
    !enabled
    || !text
    || (requiresAuth !== isAuthenticated)
    || (adminOnly && !isAdmin)
  ) {
    return null;
  }
  return (
    <li
      data-qa={dataQa}
      className={`block menu-item-animate ${active ? 'sidebarLink-active-highlight' : ''}`}
      style={{
        fontFamily: "Verdana, Geneva, sans-serif",
        fontSize: "16px",
        lineHeight: "16px",
        color: "#4c4c4c"
      }}
      onClick={onClick}
    >
      {external ? (
        <a
          href={href || undefined}
          target={newTab ? "_blank" : "_self"}
          className='py-10 pl-10 pr-20 menu-item-text'
        >
          {text}
        </a>
      ) : (
        <Link
          to={{
            pathname: route,
            state
          }}
          target={newTab ? "_blank" : "_self"}
          className='py-10 pl-10 pr-20 menu-item-text'
        >
          {text}
        </Link>
      )}
    </li>
  );
};

export default SidebarLink;
